import { Button, EButtonColor, HeroSection, Section, SectionSubtitle, SectionTitle } from '@web_opxp/components';
import { ETagType, renderStringToReact } from '@web_opxp/features';
import React, { useCallback, useEffect } from 'react';
import { connect } from 'react-redux';
import './Bridge.scss';
import * as Selectors from './selectors';
import { BridgeActions } from './slice';
import { IBaseBridgeAction } from './types';
import { canCloseBridge, getNamespace } from './utils';

export interface IBridgeOwnProps {
  language: string;
}

export interface IBridgeProps extends IBridgeOwnProps {
  action?: IBaseBridgeAction;
  filterid: number;
  onCta: (filterid: number) => void;
  onClose: (filterid: number) => void;
}

export const BridgeFC: React.FC<IBridgeProps> = ({ action, filterid, language, onClose, onCta }) => {
  const ctaHandler = () => onCta(filterid);
  const closeHandler = useCallback(() => onClose(filterid), [filterid, onClose]);

  useEffect(() => {
    if (!action || !language) {
      return;
    }
    const namespace = getNamespace(action, language);
    if (!namespace.title) {
      closeHandler();
    }
  }, [action, language, closeHandler]);

  if (!action || !filterid) {
    return null;
  }
  const { title, subtitle, content, label, image, skip } = getNamespace(action, language);
  const contentHtml = renderStringToReact(content, ETagType.div, 'col-6 bridge-content');

  const subtitleContainsParagraph = subtitle?.slice(0, 3) === '<p>';
  const sectionSubtitle = subtitle ? <SectionSubtitle>{subtitle}</SectionSubtitle> : null;
  const htmlSectionSubtitle = (
    <SectionSubtitle wrapperTag="div">{renderStringToReact(subtitle ?? '', ETagType.div)}</SectionSubtitle>
  );

  const skipButton = canCloseBridge(action) ? (
    <Button color={EButtonColor.white} label={skip} className="bridge-button" type="button" onClick={closeHandler} />
  ) : null;

  return (
    <div className="bridge">
      <HeroSection imgSrc={image} className="bridge-hero-section">
        <SectionTitle>{title}</SectionTitle>
        {subtitleContainsParagraph ? htmlSectionSubtitle : sectionSubtitle}
        <div className="buttons-container">
          <Button
            color={EButtonColor.white}
            label={label}
            className="bridge-button"
            type="button"
            onClick={ctaHandler}
          />
          {skipButton}
        </div>
      </HeroSection>
      <Section className="bridge-section">
        <div className="row">
          {contentHtml}
          <div className="col-6" />
        </div>
      </Section>
    </div>
  );
};

export const mapStateToProps = (state: Selectors.IAppState) => {
  const filterid = Selectors.getCurrentActionFilterId(state);
  const action = Selectors.getCurrentAction(state);
  return {
    action,
    filterid,
  };
};

export const mapDispatchToProps = {
  onCta: BridgeActions.ctaBridgeAction,
  onClose: BridgeActions.closeBridgeAction,
};

const Bridge = connect(mapStateToProps, mapDispatchToProps)(BridgeFC);
Bridge.displayName = 'Bridge';
export default Bridge;
